module.exports = __webpack_public_path__ + "img/shipbuild-badge.873e0702.png";